/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { MappedInput } from "@bit/the-glue.frontendcomponents.input";
import { MappedSelect } from "@bit/the-glue.frontendcomponents.select";
import { stateOptions } from "../ChemClearBooking/constants";
import { Autocomplete } from "../../../ui/components/Autocomplete";

export const SiteAddress = ({
  siteValues = {},
  handleSiteListen,
  handleOpen,
  initialValues,
  fetchLgaRegions
}) => {
  const { values, setFieldValue } = useFormikContext();
  const {
    physical_address,
    physical_city,
    physical_state,
    physical_postcode
  } = values;

  const handleAddressBlur = name => {
    if (
      !physical_address ||
      !physical_city ||
      !physical_state ||
      !physical_postcode
    )
      return;
    if (initialValues[name] === values[name]) return;
    handleOpen();
  };

  useEffect(() => {
    Object.keys(siteValues).forEach(fieldName => {
      setFieldValue(fieldName, siteValues[fieldName]);
    });
  }, [siteValues]);

  useEffect(() => {
    if (!values.physical_postcode) return;
    if (
      values.physical_postcode.length > 3 &&
      /^[0-9]+$/.test(values.physical_postcode)
    ) {
      fetchLgaRegions(values, setFieldValue);
    }
  }, [values.physical_postcode]);

  return (
    <div className="col-6">
      <h4 className="mb-5">
        <strong>Physical Address</strong>
      </h4>
      <div className="mb-7">
        <Autocomplete
          options={[]}
          name="site_address"
          placeholder="Search Address"
          hanldeFocus={handleSiteListen}
        />
      </div>
      <MappedInput
        label="Address 1"
        name="physical_address"
        onBlur={() => handleAddressBlur("physical_address")}
      />
      <MappedInput label="Address 2" name="physical_address2" />
      <MappedInput
        label="City"
        name="physical_city"
        onBlur={() => handleAddressBlur("physical_city")}
      />
      <div className="row">
        <div className="col-6">
          <MappedSelect
            label="State"
            options={stateOptions}
            name="physical_state"
            data-testid="physical_state"
            onBlur={() => handleAddressBlur("physical_state")}
          />
        </div>
        <div className="col-6">
          <MappedInput
            label="Postal Code"
            name="physical_postcode"
            onBlur={() => handleAddressBlur("physical_postcode")}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <MappedInput
            label="Latitude"
            name="physical_latitude"
            data-testid="latitude"
            disabled
          />
        </div>
        <div className="col-6">
          <MappedInput
            label="Longitude"
            name="physical_longitude"
            data-testid="longitude"
            disabled
          />
        </div>
      </div>
    </div>
  );
};
